import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';

type Props = {
  description: string,
  hosts: any[],
  lang: string,
  stringTranslations: any,
}

function About({
  description, hosts, lang, stringTranslations,
} : Props) {
  const hostNames = hosts?.map((h:any) => h.name).join(', ');
  const showHostSection = hosts?.some((h:any) => h.image);
  return (
    <div className="flex flex-col lg:flex-row mx-2 mb-[15px] lg:mb-[25px]">
      <div className={`${showHostSection ? 'lg:w-1/2 lg:mr-[50px] xl:w-3/5' : ''} flex flex-col  text-[16px] leading-[18pt] lg:leading-[19pt]`}>
        <p className="font-bold uppercase text-[24px] text-chdGreen-light leading-[26.5px] my-4 tracking-widest">{stringTranslations.about[lang]}</p>
        {description && (
        <div
          className="mb-[20px] break-words"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: description }}
        />
        )}
        {hostNames && (
          <div className="mb-[20px]">
            <p>
              {stringTranslations.show_host[lang]}
              :
              {' '}
              {hostNames}
            </p>
          </div>
        )}
        <div>
          <p>
            <em>{stringTranslations.show_disclaimer[lang]}</em>
          </p>
        </div>
      </div>
      {showHostSection && (
      <div className="flex flex-col lg:w-1/2 xl:w-2/5">
        <p className="font-bold uppercase text-[24px] text-chdGreen-light leading-[26.5px] my-4 tracking-widest">{stringTranslations.show_host[lang]}</p>
        <div className="flex flex-wrap">
          {hosts.filter((h:any) => h.image).map((h) => (
            <div key={h.id} className="w-1/2 xs:w-1/3 sm:w-[130px] pr-3 lg:mr-2">
              <GatsbyImage
                image={getImage(h.image?.gatsbyImageData)!}
                alt={h.image.description}
              />
              <p className="my-3 text-center">{h.name}</p>
            </div>
          ))}
        </div>
      </div>
      )}
    </div>
  );
}

export default About;
